import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetallePorCerealLinea4Service {
  static async getDataTablaDetallePorCerealLinea4 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector4')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 4.')
      return (data)
    })
  }

  static async getDataTablaDetallePorCerealLinea4Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_cereal_sector4_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 4.')
      return (data)
    })
  }
}
